export const enData = `
  <div class="paragraph">
    <div class="page-title">Trade-In Frequently Asked Questions (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">What should I consider when selling a mobile phone to Danghuan?</div>
    <div class="text-box">
      <div class="text">
        The mobile phone must be reset, with all personal data and PINs removed. For iPhones: make sure the device is disconnected from your iCloud account.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if the condition of my phone is evaluated differently than mine?</div>
    <div class="text-box">
      <div class="text">
        In the event that we detect a discrepancy in the condition of the device, we will inform you and offer a new price based on our technical evaluation. If our team determines that the device is in better condition than you indicated, we will also notify you.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">When will my device be inspected?</div>
    <div class="text-box">
      <div class="text">
        Most shipments are reviewed with our inspection software within a few minutes after arrival.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens with my data?</div>
    <div class="text-box">
      <div class="text">
        Please make sure all your data has been removed before sending us your mobile phone. If any data remains on the device upon arrival, we will notify you and ask for your permission to delete it.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Should I send the accessories?</div>
    <div class="text-box">
      <div class="text">
        It is not mandatory, but we recommend including them to maximize the recycling process. Sending additional accessories contributes to a more efficient resource management and helps reduce the environmental impact.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Should I send my headphones?</div>
    <div class="text-box">
      <div class="text">
        It is not necessary. For hygiene reasons, the headphones will be discarded and will not be part of the evaluation process.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Should I send the invoice for my mobile phone?</div>
    <div class="text-box">
      <div class="text">
        It is not necessary. You can keep it for your records, as we do not require it for the evaluation process.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if my device is in bad condition?</div>
    <div class="text-box">
      <div class="text">
        We will evaluate your device using a clear and fair standard, and we will send you the evaluation via email as soon as possible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Can I sell a phone with a SIM lock?</div>
    <div class="text-box">
      <div class="text">
        No, unfortunately, we cannot buy mobile phones that have a SIM lock.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Does Danghuan only buy mobile phones or also other devices?</div>
    <div class="text-box">
      <div class="text">
        We also buy other electronic devices, such as tablets, smartwatches, and laptops.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How do you rate the mobile phones and other devices sold in your Amazon, Back Market, and Wallapop stores?</div>
    <div class="text-box">
      <div class="text">
        We perform a complete diagnostic and visual inspection on all our phones and tablets. Each device is individually tested and assigned a rating based on its physical appearance and its functionality. The ratings are explained below:
      </div>
      <div class="text">
        <strong>Brand New in Box:</strong> Product in its original box. No signs of use and in perfect working condition.
      </div>
      <div class="text">
        <strong>Refurbished in Like-New Condition:</strong> Premium 'like-new' at a reduced price. No signs of use and packaged in our box.
      </div>
      <div class="text">
        <strong>Refurbished in Excellent Condition:</strong> Product in excellent condition with isolated wear on the front, back, or sides. Fully functional.
      </div>
      <div class="text">
        <strong>Refurbished in Good Condition:</strong> Product in average condition with signs of use. Shows wear on the front, back, or sides. Fully functional.
      </div>
      <div class="text">
        <strong>Refurbished in Fair Condition:</strong> Used product in fair condition with signs of heavy wear on the front, back, or sides. Fully functional with a battery health of over 70%.
      </div>
      <div class="text">
        All our products have been tested by an electronic device specialist and reviewed to ensure their quality before being shipped.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Can I cancel my sale?</div>
    <div class="text-box">
      <div class="text">
        Of course. However, this can only be done until the moment we process the payment to you.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How can I cancel an order?</div>
    <div class="text-box">
      <div class="text">
        If you have received a sales confirmation email but wish to cancel the order, you can send an email to our Customer Service team at <span class="email">order@danghuan.au.com</span>. They will assist you with the cancellation.
      </div>
    </div>
  </div>
`;